module.exports = __webpack_public_path__ + "media/bahnhof_hintergrund.0cc135f9.mp4";